module.exports = __webpack_public_path__ + "static/ogThumbnail-4b1f7ba57e0c55116a2ab22821b79743.jpg";